export interface InventoryItemProductDto {
  requesterSku: string;
  supplierSku: string;
  description: string;
}

export interface InventoryItemPartnerDto {
  id: string;
  name: string;
}

export interface InventoryItemSiteDto {
  id: string;
  name: string;
  code: string;
  supplierPartnerId: string;
}

export interface InventoryItemQuantitiesDto {
  total: number;
  released: number;
  quarantined: number;
  unallocated: number;
  allocated: number;
}

export interface InventoryItemFlagsDto {
  lowStock?: boolean;
  nearExpiry: boolean;
  extendedQC: boolean;
}

export interface InventoryItemDto {
  id: string;
  product: InventoryItemProductDto;
  supplier: InventoryItemPartnerDto;
  site: InventoryItemSiteDto;
  quantities: InventoryItemQuantitiesDto;
  flags: InventoryItemFlagsDto;
  updatedAt: Date | string;
}

export enum InventoryFlagType {
  HAS_LOW_STOCK = 'hasLowStock',
  HAS_NEAR_EXPIRY = 'hasNearExpiry',
  HAS_EXTENDED_QC = 'hasExtendedQC',
}

export interface InventoryFlagFilterDto {
  type: InventoryFlagType;
  value: boolean;
}

export interface InventoryListFilters extends Record<string, unknown> {
  size: number;
  limit?: number;
  page: number;
  sort?: string;
  direction?: 'ASC' | 'DESC';
  term?: string;
  supplierPartnerId?: string;
  inventorySiteId?: string;
  flags?: InventoryFlagFilterDto[];
}

export interface InventoryBatchDto {
  id: string;
  batchId: string;
  status: 'released' | 'quarantined' | 'blocked';
  quantities: {
    total: number;
    allocated: number;
    unallocated: number;
  };
  dates: {
    manufactureDate?: Date | string;
    expiryDate: Date | string;
    releaseDate?: Date | string;
    daysInQuality?: number;
  };
  flags?: InventoryItemFlagsDto;
  updatedAt: Date | string;
}

export interface UpdateInventoryBatchPayload {
  allocated?: number;
  manufactureDate?: string | null;
}

export interface InventoryMetricsDto {
  lowStock: number;
  nearExpiry: number;
  extendedQC: number;
  totalSkus: number;
  totalSites: number;
}

export interface InventoryExceptionItemDto {
  id: string;
  reference: string;
  skuId: string;
  sku: string;
  productName: string;
  supplier: string;
  site: string;
  quantity: number;
  expiryDate?: string;
  daysInQuality?: number;
}

export interface InventoryExceptionsDto {
  nearExpiry: InventoryExceptionItemDto[];
  extendedQC: InventoryExceptionItemDto[];
  lowStock: InventoryExceptionItemDto[];
  total: number;
}
